<template>
  <div class="inside_container">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <section class="top_banner">
      <div class="middle_content img_default" :style="getBackgrounUrl(currentArea.banner_img)">
        <p class="left_p">プランお申し込みページ</p>
        <div>
          <h3>{{currentArea.title}}</h3>
          <p class="sub_title">- {{currentArea.name}} -</p>
        </div>
      </div>
    </section>
    <section class="area_content">
      <div class="choosed_area clearfix">
        <p class="left_p">選択中のプラン</p>
        <p class="area_title">“ {{currentCountry.title}} ”プラン</p>
      </div>
      <h3 class="top_title">
        <span class="img_default">詳細プラン選択</span>
      </h3>
      <div class="travel_plan_content_two clearfix">
        <a :href="getProductUrl(currentCountry.sns_code)" class="plan_info">
          <!--<a href class="plan_info" @click="onSelectPageCode(currentCountry.sns_code)">-->
          <div class="labels clearfix">
            <p v-if="currentCountry.recommend" class="star img_default">オススメ</p>
            <p v-if="currentCountry.hot" class="hot">人気国</p>
          </div>
          <div class="country_amount img_default">
            <h4>“{{currentCountry.title}}プレミアム”プラン</h4>
            <p>最安{{snsPrice}}円/日〜</p>
          </div>
          <div class="country_info clearfix">
            <div class="sub_info_box">
              <p
                style="font-size: 15px; font-weight: 500;"
              >{{currentCountry.title}}国内で制限のあるGoogle、Youtube、Facebook、Twitter、LINEを利用することができるようになるプラン！</p>
              <ul class="note">
                <li>
                  <p>※{{currentCountry.title}}内に限ります。</p>
                </li>
                <li>
                  <p>※上記エリア内で500MBの容量のみになります。</p>
                </li>
                <li>
                  <p>※jetfi端末と仕様が異なるため日本国内でのご利用はできません。日本で起動した際にエラーコードが出ますが問題ありません。</p>
                </li>
                <li>
                  <p>※jet-phoneオプションのご利用はできません。</p>
                </li>
              </ul>
            </div>
            <div class="SNS_icon img_default">
              <p>＼ SNSを使いたい人は必須 ／</p>
            </div>
          </div>
        </a>
        <!-- <a :href="getProductUrl(currentCountry.page_code)" class="plan_info right_info clearfix">
          <div class="for_left clearfix">
            <div class="country_amount img_default">
              <h4>“通常”プラン</h4>
              <p>最安{{pagePrice}}円/日〜</p>
            </div>
            <p class="top_note">※SNSがご利用いただけません</p>
          </div>
          <div class="country_info clearfix">
            <div class="SNS_icon img_default"></div>
          </div>
        </a> -->
      </div>
      <div class="premium_plan clearfix">
        <div class="text_info">
          <h4>Q. 中国プレミアムプランとはなんですか？</h4>
          <p>
            通常、中国本土では通信制限がかかっており、Google, Youtube, Facebook, Twitter, LINE等が使えません。
            <br />中国プレミアムプランをお申込みいただく事で、中国本土でもGoogle, Youtube, Facebook, Twitter, LINEを自由にご利用いただけます。
            <br />お仕事や旅行にて中国に滞在される際、上記サービスを使われる方は必ず中国プレミアムプランをお申込みください。
          </p>
        </div>
        <div class="plan_img clearfix">
          <div>
            <img src="images/vpn_01.png" alt="中国プレミアムプラン" />
            <p>中国プレミアムプラン</p>
          </div>
          <div>
            <img src="images/vpn_02.png" alt="通常プラン" />
            <p>通常プラン</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

export default {
  name: "JetfiSelectSns",
  props: {},
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      baseImageUrl: process.env.VUE_APP_BASE_IMAGE_URL,
      priceUrl: process.env.VUE_APP_PRICE_API,
      bid: process.env.VUE_APP_PLAN_BID,
      prices: [],
      isLoading: false,
      fullPage: true,
      currentCountryId: null,
      currentCountry: {},
      currentPageCode: null,
      //currentCountry: null,
      isCountriesLoaded: false,
      isProductssLoaded: false,
      currentArea: {},
      getAreaErrorMessage: "",
      isAreaLoaded: false,
      selectedAreaId: null
    };
  },
  created: function() {
    console.log(this.$store.state.isAreasLoaded);
    this.selectedAreaId =
      this.$router.currentRoute.query.aid ||
      Vue.$sessionStorage.get("currentArea") ||
      this.$store.state.currentArea;

    this.initialize();
  },
  mounted: function() {},
  methods: {
    initialize() {
      console.log("[JetfiSelectCh] initialize");
      this.isLoading = true;
      this.getAreaById();

      this.currentCountryId =
        this.$router.currentRoute.query.cid ||
        Vue.$sessionStorage.get("currentCountry") ||
        this.$store.state.currentCountry;
      //this.currentCountryName = Vue.$sessionStorage.get("currentCountryName");
      this.currentPageCode =
        this.$router.currentRoute.query.pcode ||
        Vue.$sessionStorage.get("currentPageCode") ||
        this.$store.state.currentPageCode;

      if (!this.currentCountryId) {
        let params = Object.assign({}, this.$router.currentRoute.query);
        delete params["cid"];
        delete params["pcode"];
        this.$router.push({
          path: "countries",
          query: params
        });
      } else {
        //this.currentCountryId = Vue.$sessionStorage.get("currentCountry") || this.$store.state.currentCountry;
        //this.currentPageCode = Vue.$sessionStorage.get("currentPageCode") || this.$store.state.currentPageCode;
        this.getCountryById();
      }
    },
    getBackgrounUrl(img) {
      // console.log(area.img_src)
      // let imageUrl = "images/" + area.img_src;
      if (img) {
        let imageUrl = encodeURI(this.baseImageUrl + "/" + img);
        //console.log(imageUrl);
        return {
          "background-image": `url(${imageUrl})`
        };
      } else {
        return {};
      }
    },
    getAreaById() {
      console.log("[JetfiSelectCh] get area by id");
      this.$store
        .dispatch("getAreaById", {
          params: {
            aid: this.selectedAreaId,
            type: this.$router.currentRoute.query.t,
            short: true
          }
        })
        .then(() => {
          console.log("[JetfiSelectCh] store area:", this.$store.state.area);
          this.isAreaLoaded = this.$store.state.isAreaLoaded;
          this.errorMessage = this.$store.state.getAreaErrorMessage;
          this.currentArea = this.$store.state.area;
        });
    },
    getCountryById() {
      console.log("[JetfiSelectCh] get country by id");
      this.$store
        .dispatch("getCountryById", {
          params: {
            cid: this.currentCountryId,
            type: this.$router.currentRoute.query.t,
            short: true
          }
        })
        .then(() => {
          console.log(
            "[JetfiSelectCh] store country:",
            this.$store.state.country
          );
          this.isCountryLoaded = this.$store.state.isCountryLoaded;
          this.errorMessage = this.$store.state.getCountryErrorMessage;
          this.currentCountry = this.$store.state.country;
          this.getMinPrice();
        });
    },
    getMinPrice() {
      console.log("[JetfiSelectCh] get min price", this.currentCountry);
      axios
        .post(
          this.priceUrl,
          {
            business_id: this.bid,
            distributorCode: this.$router.currentRoute.query.d,
            couponCode: this.$router.currentRoute.query.c,
            pageCodes: [
              this.currentCountry.sns_code,
              this.currentCountry.page_code
            ]
          },
          {
            withCredentials: false //allow cookie
          }
        )
        .then(response => {
          console.log("[JetfiSelectCh] get min price done", response.data);
          this.prices = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log("[JetfiSelectCh] get min price failed", error.response);
          console.log(error);
          this.isLoading = false;
        });
    },
    getProductUrl(pcode) {
      let param = Object.assign({}, this.$router.currentRoute.query);
      param["pcode"] = pcode;
      const { href } = this.$router.resolve({
        path: "products",
        query: param
      });
      return href;
    },
    onSelectPageCode: function(pageCode) {
      this.$store.dispatch("SetCurrentPageCode", pageCode).then(() => {
        console.log(
          "[JetfiSelectCh] SetCurrentPageCode done:",
          this.$store.state.currentPageCode
        );
        this.$router.push({
          path: "products",
          query: this.$router.currentRoute.query
        });
      });
    }
  },
  computed: {
    snsPrice: function() {
      //return 100
      let self = this;
      let item = self.prices.length
        ? self.prices.filter(function(data) {
            console.log(data.pageCode === self.currentCountry.sns_code);
            return data.pageCode === self.currentCountry.sns_code;
          })
        : null;
      return item && item.length ? item[0].minPrice : "???";
    },
    pagePrice: function() {
      //return 100
      let self = this;
      let item = self.prices
        ? self.prices.filter(function(data) {
            return data.pageCode === self.currentCountry.page_code;
          })
        : null;

      return item && item.length ? item[0].minPrice : "???";
    }
  },
  components: {
    Loading
  }
};
</script>